import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { License } from './license';
import { PrimaryTradeLicenseRequirement } from './primary-trade-license-requirement';
import { VendorTrade } from './vendor-trade';

export class TradeLicense extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static TradeLicenseProperties: (
    | {
        property: keyof TradeLicense;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof TradeLicense;
        type: 'alias';
      }
    | {
        property: keyof TradeLicense;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'LicenseId', type: 'column', dataType: 'number' },
    { property: 'VendorTradeId', type: 'column', dataType: 'number' },
    {
      property: 'PrimaryTradeLicenseRequirementId',
      type: 'column',
      dataType: 'number'
    },
    { property: 'isNotArchived', type: 'column', dataType: 'boolean' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'VendorTrade', model: 'VendorTrade', type: 'association' },
    { property: 'License', model: 'License', type: 'association' },
    {
      property: 'PrimaryTradeLicenseRequirement',
      model: 'PrimaryTradeLicenseRequirement',
      type: 'association'
    }
  ];

  static {
    TradeLicense.TradeLicenseProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        TradeLicense.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        TradeLicense.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        TradeLicense.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(TradeLicenseObject: Partial<TradeLicense>) {
    super();

    TradeLicense.TradeLicenseProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = TradeLicenseObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  LicenseId?: number;
  VendorTradeId?: number;
  PrimaryTradeLicenseRequirementId?: number;
  isNotArchived?: boolean;
  createdAt?: Date;
  updatedAt?: Date;

  VendorTrade?: VendorTrade;
  License?: License;
  PrimaryTradeLicenseRequirement?: PrimaryTradeLicenseRequirement;
}
